import * as React from "react";
import { TableHeaderStyled } from "./styled";

interface Props {
  children?: JSX.Element | JSX.Element[];
}

const TableHeader: React.FC<Props> = (props: Props): JSX.Element => {
  return (
    <TableHeaderStyled>
      {Array.isArray(props.children)
        ? props.children.map((child) => child)
        : props.children}
    </TableHeaderStyled>
  );
};

export default TableHeader;
